import { render, staticRenderFns } from "./ListaProdutosDoPedido.vue?vue&type=template&id=7724c307"
import script from "./ListaProdutosDoPedido.vue?vue&type=script&lang=js"
export * from "./ListaProdutosDoPedido.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutosDoPedido.vue?vue&type=style&index=0&id=7724c307&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports